module.exports = __webpack_public_path__ + "img/calcados.8d7a08aa.png";